import { render, staticRenderFns } from "./ShopProductPreview.vue?vue&type=template&id=c82771f0&scoped=true&"
import script from "./ShopProductPreview.vue?vue&type=script&lang=js&"
export * from "./ShopProductPreview.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductPreview.vue?vue&type=style&index=0&id=c82771f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82771f0",
  null
  
)

export default component.exports